module.exports = __webpack_public_path__ + "static/CircularStd-Book.e2652d8d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularStd-Book.woff
// module id = 467
// module chunks = 114276838955818